"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const formik_1 = require("formik");
const react_native_paper_dates_1 = require("react-native-paper-dates");
const styles_1 = __importDefault(require("../../styles/styles"));
const themes_1 = __importDefault(require("../../styles/themes"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const select_1 = __importDefault(require("../select/select"));
const button_1 = __importDefault(require("../button/button"));
const eventConstants_1 = require("../../constants/eventConstants");
const utils_1 = require("../../utils/utils");
const pressable_1 = __importDefault(require("../pressable/pressable"));
const ticketUtils_1 = require("../ticketComponent/ticketUtils");
const officersSlice_1 = require("../../features/officer/officersSlice");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const actionsSlice_1 = require("../../features/actions/actionsSlice");
const filterCallRecordConstants_1 = require("../filterCallRecord/filterCallRecordConstants");
const filterScehduleActionsConstants_1 = require("./filterScehduleActionsConstants");
const FilterScheduleActions = ({ queryParams, setQueryParams, }) => {
    const today = new Date();
    const dispatch = useAppDispatch_1.default();
    const { officers } = useAppSelector_1.default((state) => ({
        officers: state.officers.officers.data,
    }));
    const [actionType, setActionType] = react_1.useState(queryParams.action_type);
    const [scheduleCategory, setScheduleCategory] = react_1.useState(queryParams.category);
    const [notesAvailability, setNotesAvailability] = react_1.useState(queryParams.notes_availability);
    const [actionDateModalVisible, setActionDateModalVisible] = react_1.useState(false);
    const [actionDate, setActionDate] = react_1.useState(queryParams.datetime_created ? new Date(queryParams.datetime_created) : undefined);
    const formattedActionDate = actionDate && utils_1.formatDateISOString(actionDate);
    react_1.useEffect(() => {
        dispatch(officersSlice_1.getOfficers({}));
    }, []);
    const onSearch = (input) => ticketUtils_1.searchOfficers(dispatch, input);
    const officerChoices = ticketUtils_1.generateOfficerChoices(officers);
    const onDateModalConfirm = (params) => {
        setActionDateModalVisible(false);
        setActionDate(params.date);
    };
    const onSubmit = (payload) => {
        const updatedPayload = {
            ...payload,
            action_type: actionType,
            notes_availability: notesAvailability,
            category: scheduleCategory,
            datetime_created: formattedActionDate,
        };
        dispatch(actionsSlice_1.getScheduleActions(updatedPayload));
        setQueryParams(updatedPayload);
    };
    const getFieldValue = (field, value) => {
        const formattedField = utils_1.formatTitle(field);
        if (field === 'officer_id') {
            const officerMappings = utils_1.mapStatusChoices(officerChoices);
            const label = officerMappings.get(value);
            return [label ? 'Officer' : formattedField, label || value];
        }
        if (filterScehduleActionsConstants_1.FIELD_MAPPING.has(field)) {
            const labelMapping = filterScehduleActionsConstants_1.FIELD_MAPPING.get(field);
            return [formattedField, labelMapping.get(value) || value];
        }
        return [formattedField, value];
    };
    return (react_1.default.createElement(react_native_paper_1.Card, { style: [styles_1.default.whiteBackground] },
        react_1.default.createElement(react_native_paper_1.Card.Title, { title: "Filters", titleStyle: styles_1.default.textColorBlack }),
        react_1.default.createElement(react_native_paper_1.Card.Content, null,
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexWrap] }, Object.entries(queryParams).map(([field, value]) => !utils_1.isEmptyOrUndefined(value) && (react_1.default.createElement(react_native_paper_1.Chip, { key: field, style: [styles_1.default.blueBackground, styles_1.default.marginFive], textStyle: styles_1.default.textColorWhite, mode: "outlined", onClose: () => {
                    setQueryParams({ ...queryParams, [field]: '' });
                    dispatch(actionsSlice_1.getScheduleActions({ ...queryParams, [field]: '' }));
                } }, getFieldValue(field, value).join(' is '))))),
            react_1.default.createElement(formik_1.Formik, { initialValues: queryParams, onSubmit: (values) => onSubmit(values) }, ({ handleChange, handleSubmit, values }) => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexWrap] },
                    react_1.default.createElement(react_native_paper_dates_1.DatePickerModal, { locale: "en", mode: "single", visible: actionDateModalVisible, onDismiss: () => setActionDateModalVisible(false), date: actionDate, onConfirm: onDateModalConfirm, label: "Select action date", validRange: {
                            endDate: today,
                        } }),
                    react_1.default.createElement(react_native_paper_1.TextInput, { label: "ID", onChangeText: handleChange('id'), value: values.id || '', style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
                    react_1.default.createElement(react_native_paper_1.TextInput, { label: "Schedule ID", onChangeText: handleChange('schedule_id'), value: values.schedule_id || '', style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
                    react_1.default.createElement(pressable_1.default, { onPress: () => setActionDateModalVisible(true), eventName: eventConstants_1.SELECT_SCHEUDLE_ACTION_DATE_BUTTON },
                        react_1.default.createElement(react_native_paper_1.TextInput, { label: "Date", value: formattedActionDate, left: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput })),
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.minWidth] },
                        react_1.default.createElement(select_1.default, { value: values.officer_id, setValue: () => { }, setValueFormik: handleChange('officer_id'), choices: officerChoices, style: styles_1.default.select, searchable: true, onSearch: onSearch })),
                    react_1.default.createElement(react_native_1.View, { style: [{ width: 180 }] },
                        react_1.default.createElement(select_1.default, { value: actionType, setValue: setActionType, choices: filterScehduleActionsConstants_1.ACTION_TYPES_CHOICES, style: { height: 60 } })),
                    react_1.default.createElement(react_native_1.View, { style: [{ width: 180 }] },
                        react_1.default.createElement(select_1.default, { value: scheduleCategory, setValue: setScheduleCategory, choices: filterCallRecordConstants_1.SCHEDULE_CATEGORY_CHOICES, style: { height: 60 } })),
                    react_1.default.createElement(react_native_1.View, { style: [{ width: 180 }] },
                        react_1.default.createElement(select_1.default, { value: notesAvailability, setValue: setNotesAvailability, choices: filterScehduleActionsConstants_1.NOTES_AVAILABILITY_CHOICES, style: { height: 60 } }))),
                react_1.default.createElement(react_native_paper_1.Card.Actions, null,
                    react_1.default.createElement(button_1.default, { onPress: handleSubmit, eventName: eventConstants_1.FILTER_SCHEDULE_ACTION_BUTTON, text: `Filter ` }))))))));
};
exports.default = FilterScheduleActions;
